import React from "react";
import TableProcesos from "../components/TablePisccReportes";
import AddReporte from './AddReporteContainer'
import WatchReporte from './WatchReportContainer'

import Landing from "../../landing/containers/LandingContainer";
import PisccComponent from "../components/PisccComponent";
import { makeId, sendService } from '../../Services/service'

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modalActions from "../../Actions/Modal";
import * as dashActions from "../../Actions/Dashboard";
import * as sessionActs from "../../Actions/Session";

import "./../style.css";

const vectores = {
  alcance: [
    { id: 1, text: "PISCC" },
    { id: 2, text: "Plan de Desarrollo" },
  ],
  nivelAlcance: [
    { id: 1, text: "Responsabilidad propia de ejecución (PISCC)" },
    { id: 2, text: "Control y verificación en ejecución (PISCC)" },
    { id: 3, text: "Parcticipación en ejecución (PISCC)" },
    { id: 4, text: "Responsabilidad propia de ejecución (PDD)" },
    { id: 5, text: "Recomendaciones para ejecución (PDD)" },
    { id: 6, text: "Control y verificación en ejecución (PDD)" },
    { id: 7, text: "Parcticipación en ejecución (PDD)" },
  ],
};

class PisccContainer extends React.Component {
  state = {
    // procesos: { count: 0, page: 0, pages: 0, pageSize: 20 },
    content: [],
    indicators: [],
    texto: "",
    filter: {
      alcance: [],
      nivelAlcance: [],
      textos: [],
      year: [new Date().getFullYear().toString()],
      socketPath: makeId()
    },
    filterArray: [{ id: new Date().getFullYear().toString(), title: new Date().getFullYear().toString(), variable: "year" }],
    indYear: 0,
    indTot: 0,
    nivel: 0,
  };

  handlerKeyPress = (e) => {
    if (e.key === "Enter") this.handlerChange("textos", this.state.texto);
  };

  handlerChange = (variable, value) => {
    if (variable === "texto") {
      this.setState({ texto: value });
      return;
    } else if (variable === "textos") this.setState({ texto: "" });

    let filtroActual = JSON.parse(JSON.stringify(this.state.filter));
    const esta = filtroActual[variable].findIndex((f) => f === value);

    if (esta > -1) filtroActual[variable].splice(esta, 1);
    else filtroActual[variable].push(value);

    const itemsAlcance = this.getFilterArrayByItem(
      filtroActual,
      vectores,
      "alcance"
    );
    const itemsNivelAlcance = this.getFilterArrayByItem(
      filtroActual,
      vectores,
      "nivelAlcance"
    );
    const itemsTextos = this.getFilterArrayByItem(
      filtroActual,
      null,
      "textos",
      true
    );
    const itemsYears = this.getFilterArrayByItem(
      filtroActual,
      null,
      "year",
      true
    );

    this.setState({
      filter: filtroActual,
      filterArray: [itemsAlcance, itemsNivelAlcance, itemsTextos, itemsYears].flat(),
    });
  };

  getFilterArrayByItem = (vectorStado, vectorDatos, variable, title = null) => {
    return vectorStado[variable].map((a) => {
      return {
        id: a,
        title: title
          ? a
          : vectorDatos[variable]
            .filter((f) => f.id === parseInt(a))
            .reduce((pre, cur) => cur.text, ""),
        variable,
      };
    });
  };

  componentDidMount() {
    this.loadPiscc()
  }

  loadPiscc = () => {
    sendService("/api/v1/piscc/pisccData").then(resp => {
      const activated = resp.response.map(r => { return { ...r, active: false } })
      this.setState({ content: activated, indicators: activated, filter: { ...this.state.filter, socketPath: makeId() } })
    })
  }

  componentDidUpdate() {
    if (JSON.stringify(this.state.filter) !== this.filter) {
      this.filter = JSON.stringify(this.state.filter);
      let table = JSON.parse(JSON.stringify(this.state.indicators))
      if (this.state.filter.alcance.length === 1) table = table.filter(f => this.state.filter.alcance.includes(f.refPisccAlcanceId.toString()))
      if (this.state.filter.nivelAlcance.length > 0) table = table.filter(f => this.state.filter.nivelAlcance.includes(f.refPisccNivelAlcanceId.toString()))
      if (this.state.filter.textos.length > 0) {
        table = table.filter(f => {
          return this.state.filter.textos.filter(ft => {
            if (f.linea.toLowerCase().includes(ft.toLowerCase())) return true
            if (f.indicador.toLowerCase().includes(ft.toLowerCase())) return true
            if (f.codigo.toLowerCase().includes(ft.toLowerCase())) return true
            return false
          }).reduce((pre, cur) => pre || cur, false)
        })
      }
      const selected = table.reduce((pre, cur) => pre || cur.active, false)
      const metaTot = table.filter(f => selected ? f.active : true).reduce((pre, cur) => pre + cur.meta1 + cur.meta2 + cur.meta3 + cur.meta4, 0)
      const metaYear = table.filter(f => selected ? f.active : true).reduce((pre, cur) => {
        let acc = pre
        if (this.state.filter.year.includes('2020')) acc += cur.meta1
        if (this.state.filter.year.includes('2021')) acc += cur.meta2
        if (this.state.filter.year.includes('2022')) acc += cur.meta3
        if (this.state.filter.year.includes('2023')) acc += cur.meta4
        if (this.state.filter.year.length === 0) acc = pre + cur.meta1 + cur.meta2 + cur.meta3 + cur.meta4
        return acc
      }, 0)
      const repTot = table.filter(f => selected ? f.active : true).reduce((pTab, cTab) => {
        return pTab + cTab.reportes.reduce((pre, cur) => pre + cur.value, 0)
      }, 0)
      const repYear = table.filter(f => selected ? f.active : true).reduce((pTab, cTab) => {
        return pTab + cTab.reportes.reduce((pre, cur) => {
          let acc = pre
          if (this.state.filter.year.includes(cur.anualidad.toString())) acc += cur.value
          if (this.state.filter.year.length === 0) acc += cur.value
          return acc
        }, 0)
      }, 0)
      const nivel = table.filter(f => selected ? f.active : true).reduce((pre, cur) => pre + cur['refPisccNivelAlcance.nivel'], 0)
      const indTot = metaTot === 0 ? 0 : Math.round(100 * nivel * repTot / metaTot) / 100
      const indYear = metaYear === 0 ? 0 : Math.round(100 * nivel * repYear / metaYear) / 100
      // console.log('n', nivel)
      // console.log('m', metaTot, metaYear)
      // console.log('r', repTot, repYear)
      // console.log('i', indTot, indYear)
      this.setState({ content: table, indYear, indTot, nivel })
    }
  }

  selectIndicador = id => {
    const indicators = this.state.indicators.map(i => {
      if (i.id === id)
        return { ...i, active: !i.active }
      return { ...i }
    })
    this.setState({
      filter: {
        ...this.state.filter,
        socketPath: makeId()
      },
      indicators
    })
  }

  watchIndicador = id => {
    // console.log(this.state.content.reduce((pre, cur) => pre + cur['refPisccNivelAlcance.nivel'], 0))
    const indicador = this.state.indicators.filter(f => f.id === id).reduce((pre, cur) => cur, {})
    this.props.modalActions.openModal(<WatchReporte indicador={indicador} close={this.props.modalActions.closeModal} vectors={vectores} reload={this.loadPiscc} />)
  }

  addIndicador = id => {
    const indicador = this.state.indicators.filter(f => f.id === id).reduce((pre, cur) => cur, {})
    this.props.modalActions.openModal(<AddReporte indicador={indicador} close={this.props.modalActions.closeModal} reload={this.loadPiscc} />)
  }

  render() {
    return (
      <>
        <Landing history={this.props.history} hasFooter={false}>
          <>
            <PisccComponent
              state={this.state}
              alcance={vectores.alcance}
              nivelAlcance={vectores.nivelAlcance}
              onChange={this.handlerChange}
              handlerKeyPress={this.handlerKeyPress}
              closeTagText={this.selectIndicador}
            />
            <div className="work-sheet-city-card-2">
              <div className="content-consulta" style={{ marginBottom: '10px' }}>
                <TableProcesos
                  content={this.state.content}
                  years={this.state.filter.year}
                  select={this.selectIndicador}
                  add={this.addIndicador}
                  watch={this.watchIndicador}
                />
              </div>
            </div>
          </>
        </Landing>

      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActions, dispatch),
    dashActions: bindActionCreators(dashActions, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PisccContainer);
